import { Pipe, PipeTransform } from '@angular/core';
import { CountryCode, parsePhoneNumberWithError } from 'libphonenumber-js';

@Pipe({
  name: 'phoneNumber',
})
export class PhonePipe implements PipeTransform {
  transform(rawNum: string | number, defaultCountry: CountryCode = 'CA'): string {
    if (!rawNum && rawNum !== 0) {
      return '';
    }

    const numStr = String(rawNum);

    try {
      const phoneNumber = parsePhoneNumberWithError(numStr, defaultCountry);
      if (phoneNumber && phoneNumber.isValid()) {
        return phoneNumber.formatNational();
      }
    } catch (error) {
      console.warn('Invalid phone number format:', rawNum);
    }

    const cleanNum = numStr.replace(/\D/g, '');
    if (cleanNum.length === 11) {
      return cleanNum[0] + '-' + cleanNum.slice(1, 4) + '-' + cleanNum.slice(4, 7) + '-' + cleanNum.slice(7);
    } else if (cleanNum.length === 10) {
      return cleanNum.slice(0, 3) + '-' + cleanNum.slice(3, 6) + '-' + cleanNum.slice(6);
    }

    return numStr;
  }
}
